module.exports = __webpack_public_path__ + "static/media/wreck.c8103b07.svg";